import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { ManagerLayoutComponent } from './layouts/manager-layout/manager-layout.component';
import { WorkbenchLayoutComponent } from './layouts/workbench-layout/workbench-layout.component';
import { AuthGuard } from './guards/auth.guard';
import { RoleManagerGuard } from './guards/role-manager.guard';
import { RoleWorkbenchGuard } from './guards/role-workbench.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/auth/signin',
    pathMatch: 'full'
  },
  /**
   * AUTHENTICATION LAYOUT
   */
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: 'auth',
        loadChildren: './authentication/authentication.module#AuthenticationModule'
      },
      //  {
      //   path: 'error',
      //   loadChildren: './error/error.module#ErrorModule'
      // }
    ]
  },
  /**
   * MANAGER LAYOUT
   */
  {
    path: '',
    component: ManagerLayoutComponent,
    canActivate: [AuthGuard, RoleManagerGuard],
    children: [
      {
        path: 'manager',
        loadChildren: () => import('./views/manager/manager.module').then(m => m.ManagerModule)
      }
    ]
  },
  /**
   * workbench LAYOUT
   */
   {
    path: '',
    component: WorkbenchLayoutComponent,
    canActivate: [AuthGuard, RoleWorkbenchGuard],
    children: [
      {
        path: 'workbench',
        loadChildren: () => import('./views/workbench/workbench.module').then(m => m.WorkbenchModule)
        //loadChildren: './views/workbench/workbench.module#WorkbenchModule'
      }
    ]
  },
  { // 404
    path: '**',
    redirectTo: 'error/404'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, preloadingStrategy: PreloadAllModules})],
  exports: [ RouterModule ]
})
export class AppRoutingModule { }
